module.exports = __webpack_public_path__ + "img/acrobat-small.2d4c8cc.svg";